




















































import { Prop, Component } from 'vue-property-decorator';
import { IFormatParameter } from '@models';
import CampaignParametersFormTypeBase from '../CampaignParametersFormTypeBase/CampaignParametersFormTypeBase';
import { MacroSwapHelper } from '../../../helpers/MacroSwapHelper';


@Component
export default class CampaignParametersInsTagArea extends CampaignParametersFormTypeBase {
  name = 'campaign-parameters-instag';

  @Prop({
    type: Object as () => IFormatParameter,
    default: () => null
  })
  formatParameter: IFormatParameter;
  isDeleteAvailable: boolean = false;

  expectedTagValues: string[] = ['${CLICK_URL}', '${CLICK_URL_ENC}'];

  replaceTagMap: Map<string, string> = new Map<string, string>();

  onTextClear(event: any) {
    this.str = '';
  }

  get str() {
    return this.local.value;
  }

  set str(str: string) {
    this.update(v => {
      v.file = null;
      v.value = str;
    });

    this.isDeleteAvailable = str && str.length > 0;
  }

  get replaceableTags(): { key: string, value: string }[] {
    return MacroSwapHelper.FindReplaceableTags(this.str);
  }

  replaceTag(key: string) {
    this.str = MacroSwapHelper.ReplaceTag(key, this.str);
  }

  get insTagWarnings(): string[] {
    if (!this.str || typeof (this.str) === 'undefined' || this.str.length < 1) {
      return [];
    }

    let result: string[] = [];

    var allIncludedExpectedValues = this.expectedTagValues.filter(x => this.str.includes(x));
    if (allIncludedExpectedValues.length === 0) {
      result.push("$None of the following macros " + this.expectedTagValues[0] + " , " + this.expectedTagValues[1]+ " were located in the tag - External click tracking might be disabled.");
    }

    return result;
  }

  created() {
    this.isDeleteAvailable = this.str && this.str.length > 0;
  }
}
